import { reactive, toRefs } from '@vue/composition-api'
import Toaster from '@core/utils/sweetToast'
import store from '@/store'
import axios from 'axios'
import { nanoid } from 'nanoid'


export default () => {
  const sendMsg = async (data) => {
    const token = localStorage.getItem('token')
    try {
      return await axios.post('https://api.bldon.com/dev/ai-chat/query', data, {
        headers: {
          'x-token': token
        }
      })
    } catch (error) {
      console.log(error)
      return {data: 'Error fetching data'}
    }
     
  }

  return {
    sendMsg,
  }
}
